export * from './variablesDetailComponent';